import { Box } from "@mui/material";
import { FC, useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
const MFPaymentDone: FC = () => {
  const [loading, setLoading] = useState(true);
  let navigate = useNavigate();
  setTimeout(() => {
    navigate("/MFpaymentdone");
    setLoading(false);
  }, 10000);

  return (
    <Box
      height="100%"
      display="flex"
      flexDirection="column"
      sx={{ display: "flex", alignItems: "center", mt: 20 }}
    >
    <CircularProgress />
    </Box>
  );
};

export default MFPaymentDone;
